'use strict';

export default class Base
{
    constructor() {
        this.eventListeners = [];
    }

    addEventListener(type, eventHandler) {
        this.eventListeners.push({
            type: type,
            eventHandler: eventHandler
        });
    }

    removeEventListener(type, eventHandler) {
        let listener = {
            type: type,
            eventHandler: eventHandler
        };
        for (let key in this.eventListeners) {
            if (this.eventListeners[key].type === listener.type) {
                delete this.eventListeners[key];
            }
        }
    }

    dispatchEvent(event) {
        for (let i = 0; i < this.eventListeners.length; i++) {
            if (this.eventListeners[i] !== undefined &&
                event.type === this.eventListeners[i].type
            ) {
                this.eventListeners[i].eventHandler(event);
            }
        }
    }
}
